import { Divider } from '#app/components/ui/divider.tsx'

import {
	PolicyDocumentItem,
	type Props as PolicyDocumentItemProps,
} from '#app/routes/mocra+/_form+/policies-references/policy-document-item.tsx'

type Item = PolicyDocumentItemProps & {
	readonly key: string
}

type Props = {
	readonly items: ReadonlyArray<Item>
	readonly documentsError?: string | null
}

export function PolicyDocumentsSection({ items, documentsError }: Props) {
	return (
		<div className="space-y-10">
			{documentsError ? (
				<p className="text-destructive text-sm">{documentsError}</p>
			) : null}
			{items.map((item, index) => (
				<div key={item.key} className="space-y-6">
					<PolicyDocumentItem {...item} />
					{index < items.length - 1 ? <Divider /> : null}
				</div>
			))}
		</div>
	)
}
